import React, {
  createContext,
  useContext,
  useState,
  // useEffect, // Temporalmente comentado
  ReactNode,
} from 'react';
import { ThemeProvider as MUIThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { lightTheme } from './theme'; // darkTheme temporalmente removido

type ThemeMode = 'light' | 'dark';

interface ThemeContextType {
  mode: ThemeMode;
  toggleTheme: () => void;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

interface ThemeProviderProps {
  children: ReactNode;
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  // TEMPORAL: Forzar modo claro hasta que se arreglen los estilos del modo oscuro
  // TODO: Restaurar funcionalidad completa de modo oscuro cuando se mejoren los contrastes
  const [mode, setMode] = useState<ThemeMode>('light');

  const toggleTheme = () => {
    // Deshabilitado temporalmente
    console.log('Modo oscuro deshabilitado temporalmente');
    // const newMode = mode === 'light' ? 'dark' : 'light';
    // setMode(newMode);
    // localStorage.setItem('theme-mode', newMode);
  };

  // Listen for system theme changes - Deshabilitado temporalmente
  /*
  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = (e: MediaQueryListEvent) => {
      // Only update if no user preference is saved
      if (!localStorage.getItem('theme-mode')) {
        setMode(e.matches ? 'dark' : 'light');
      }
    };

    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);
  */

  // Forzar tema claro temporalmente
  const theme = lightTheme;

  const contextValue: ThemeContextType = {
    mode,
    toggleTheme,
  };

  return (
    <ThemeContext.Provider value={contextValue}>
      <MUIThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </MUIThemeProvider>
    </ThemeContext.Provider>
  );
};

export const useTheme = (): ThemeContextType => {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};
